import { render, staticRenderFns } from "./RevenueSave.vue?vue&type=template&id=6e6ff3b6&"
import script from "./RevenueSave.vue?vue&type=script&lang=js&"
export * from "./RevenueSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports